export const formatTime = (date: Date | string): string => {
  // Converter para Date se for string
  const dateObj = typeof date === "string" ? new Date(date) : date;
  
  // Verificar se a data é válida
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    console.warn("Data inválida passada para formatTime:", date);
    return "--:--";
  }
  
  return dateObj.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatLastSeen = (date: Date | null): string => {
  if (!date) {
    return "nunca visto";
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) {
    return "agora mesmo";
  } else if (diffMins < 60) {
    return `há ${diffMins} ${diffMins === 1 ? "minuto" : "minutos"}`;
  } else if (diffHours < 24) {
    return `há ${diffHours} ${diffHours === 1 ? "hora" : "horas"}`;
  } else if (diffDays === 1) {
    return "ontem";
  } else if (diffDays < 7) {
    return `há ${diffDays} ${diffDays === 1 ? "dia" : "dias"}`;
  } else {
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
};
